import {setBranchDaysSkeleton} from "../../../skeleton";
import React from "react";
import {withTranslate} from "react-redux-multilingual";

const Queue = ({translate, currentBranch, currentBranchDayBreaks, currentBranchDayBreaksIsLoading}) => {
    const branchDayBreaksList = currentBranchDayBreaks && currentBranchDayBreaks.length ? currentBranchDayBreaks.map((breakTime, index) => {
            return (
                <div key={index} className="break-card full-width">
                    <div className="break-card-body full-width">
                        <p className="flex-container">
                            <div className="from">
                                <span className="label">{translate("from") + " "} &nbsp;&nbsp;</span>
                                <span className="from-time bolder">{breakTime.time_from + " "}</span>
                            </div>

                            <div className="clearfix"></div>

                            <div className="to">
                                <span className="label">{"/" + " " + translate("to") + " "}</span>
                                <span className="to-time bolder">&nbsp;&nbsp;{ breakTime.time_to + " "}</span>
                            </div>

                        </p>
                    </div>
                </div>
            )
        }
    ) : null;
    return (

        <div className="queue-wrapper">
            <p className="loon2 shadow-4d bolder text-center bolder font-16">{currentBranch && currentBranch.pattern === 0 ? translate("interval_reservation_hint") : translate("queue_reservation_hint")}</p>
            <div className="breaks-wrapper"
                 hidden={currentBranchDayBreaksIsLoading || currentBranch && currentBranch.pattern === 0}>
                <p hidden={currentBranchDayBreaks && currentBranchDayBreaks.length === 0}>
                    {translate("break_times")}
                </p>
                {!currentBranchDayBreaksIsLoading ?
                    <div className="flex-container">
                        {branchDayBreaksList}
                    </div> : setBranchDaysSkeleton()
                }
            </div>
        </div>
    )
};


export default withTranslate(Queue);
